<template>
  <viewOrComment type="comment" />
</template>
<script lang="ts" setup>
import viewOrComment from './components/viewOrComment.vue'
</script>
<script lang="ts">
export default {
  name: 'DcCosLbuSupervisorAccompanyingVisitComment'
}
</script>
